import React from 'react';
import "./assets/css/bootstrap.min.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/nice-select.css";
import "./assets/css/magnific-popup.css";
import "./assets/css/slick.css";
import "./assets/css/default.css";
import "./assets/css/style.css";


export default function Footer() {
    return (
        <div className='blog_page'>
            <footer class="binduz-er-footer-area">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-9">
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <div class="binduz-er-footer-widget-style-1">
                                        <div class="binduz-er-footer-title">
                                            <h3 class="binduz-er-title">Categories</h3>
                                        </div>
                                        <div class="binduz-er-footer-menu-list">
                                            <ul>
                                                <li><a href="#">Architecture</a></li>
                                                <li><a href="#">New look 2015</a></li>
                                                <li><a href="#">Gadgets</a></li>
                                                <li><a href="#">Mobile and Phones</a></li>
                                                <li><a href="#">Recipes</a></li>
                                                <li><a href="#">Decorating</a></li>
                                            </ul>
                                            <ul>
                                                <li><a href="#">Interiors</a></li>
                                                <li><a href="#">Street fashion</a></li>
                                                <li><a href="#">Street fashion</a></li>
                                                <li><a href="#">Lifestyle</a></li>
                                                <li><a href="#">Lookback</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="binduz-er-footer-widget-style-1">
                                        <div class="binduz-er-footer-title">
                                            <h3 class="binduz-er-title">Newsletter</h3>
                                        </div>
                                        <div class="binduz-er-footer-widget-form">
                                            <form action="#">
                                                <div class="binduz-er-input-box">
                                                    <i class="fal fa-user"></i>
                                                    <input type="text" placeholder="Enter your name" />
                                                </div>
                                                <div class="binduz-er-input-box">
                                                    <i class="fal fa-envelope"></i>
                                                    <input type="email" placeholder="Enter email address" />
                                                </div>
                                                <div class="binduz-er-input-box">
                                                    <button type="button"><i class="fal fa-paper-plane"></i> Subscribe Now</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="binduz-er-footer-widget-style-3">
                                        <div class="binduz-er-footer-title">
                                            <h3 class="binduz-er-title">Recent Feeds</h3>
                                        </div>
                                        <div class="binduz-er-footer-widget-feeds">
                                            <div class="binduz-er-sidebar-latest-post-box">
                                                <div class="binduz-er-sidebar-latest-post-item">
                                                    <div class="binduz-er-thumb">
                                                        <img src={require('./assets/images/latest-post-1.jpg')} alt="latest" />
                                                    </div>
                                                    <div class="binduz-er-content">
                                                        <span><i class="fal fa-calendar-alt"></i> 24th February 2020</span>
                                                        <h4 class="binduz-er-title"><a href="#">Our commitment to COVID-19 vaccine</a></h4>
                                                    </div>
                                                </div>
                                                <div class="binduz-er-sidebar-latest-post-item">
                                                    <div class="binduz-er-thumb">
                                                        <img src={require('./assets/images/latest-post-1.jpg')} alt="latest" />
                                                    </div>
                                                    <div class="binduz-er-content">
                                                        <span><i class="fal fa-calendar-alt"></i> 24th February 2020</span>
                                                        <h4 class="binduz-er-title"><a href="#">A more helpful Chrome, throughout your</a></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="binduz-er-footer-widget-info">
                                <div class="binduz-er-logo">
                                    <a href="#"><img src={require('./assets/images/logo.png')} alt="" style={{ filter: "invert(1)" }} /></a>
                                </div>
                                <div class="binduz-er-text">
                                    <p>Lorem ipsum dolor sit amet, consec tetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspend isse ultrices gravida.</p>
                                </div>
                                <div class="binduz-er-social">
                                    <ul>
                                        <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fab fa-behance"></i></a></li>
                                        <li><a href="#"><i class="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="binduz-er-back-to-top">
                    <p>BACK TO TOP <i class="fal fa-long-arrow-right"></i></p>
                </div>
            </footer>
            <div class="binduz-er-footer-copyright-area">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="binduz-er-copyright-text">
                                <p>Copyright © 2026 Aahilya Holidays. All Rights Reserved.</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="binduz-er-copyright-menu float-lg-end float-none">
                                <ul>
                                    <li><a href="#">Useful links</a></li>
                                    <li><a href="#">Terms & Conditions</a></li>
                                    <li><a href="#">General Information</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
